module.exports = __webpack_public_path__ + "img/epr-price_medium.a1774487.webp";